import { FC } from 'react';

import Image from './image.png';

export const CustodyImage: FC = () => <img src={Image} alt="custody" />;
